// extracted by mini-css-extract-plugin
export default {"general":"FormError_general__0Dowj","specific":"FormError_specific__V16Sm"};